<div class="floori-image-gallery">
    <div class="main-view">
        @if (showImageList() && !isMobile()) {
        <button
            floori-icon-button
            [class]="'outline small ' + (isFirstImage() ? 'hidden' : '')"
            (click)="previousImage()">
            <floori-icon name="fl_chevron_left_s" />
        </button>
        }
        <div class="image-container">
            <div class="main-image-wrapper">
                @if (isMobile()) {
                <div
                    class="mobile-zoom-container"
                    (touchstart)="onTouchStart($event)"
                    (touchmove)="onTouchMove($event)"
                    (touchend)="onTouchEnd($event)">
                    <img
                        [src]="getMainImageUrl(currentImage())"
                        [class.zoomed]="isZoomed()"
                        [style.transform]="getTransform()"
                        (load)="onImageLoaded($event)" />
                </div>
                } @else {
                <lib-ngx-image-zoom
                    class="main-image"
                    [class.hidden]="!isImageLoaded()"
                    [thumbImage]="getThumbnailUrl(currentImage())"
                    [fullImage]="getMainImageUrl(currentImage())"
                    [magnification]="1"
                    [enableScrollZoom]="true"
                    [enableLens]="showZoomLens()"
                    [lensWidth]="lensSize()"
                    [lensHeight]="lensSize()"
                    [zoomMode]="'hover'"
                    (imagesLoaded)="onImageLoad($event)">
                </lib-ngx-image-zoom>
                }
            </div>

            @if (showZoomLens() && !isMobile()) {
            <div class="info-icon-wrapper">
                <floori-icon
                    name="fl_info_o"
                    [flooriTooltip]="tooltipValue()"
                    [tooltipDirection]="tooltipDirection"
                    [tooltipOnMobile]="false" />
            </div>
            }
        </div>

        @if (showImageList() && !isMobile()) {
        <button
            floori-icon-button
            [class]="'outline small ' + (isLastImage() ? 'hidden' : '')"
            (click)="nextImage()">
            <floori-icon name="fl_chevron_right_s" />
        </button>
        }
    </div>

    @if (showImageList()) {
    <p class="text-center">{{ currentIndex() + 1 }} / {{ numberOfImages() }}</p>
    <div
        class="image-list"
        [class.centered]="shouldCenterList()"
        (wheel)="onWheel($event)"
        #imageList>
        @for (image of images(); track $index) {
        <div
            class="image-list-item"
            [class.active]="$index === currentIndex()"
            (click)="goToImage($index)">
            <img loading="lazy" [src]="getThumbnailUrl(image)" [alt]="getThumbnailUrl(image)" />
        </div>
        }
    </div>
    }
</div>
